// Mock data for MVSD NDIS website
// NOTE: All content here is placeholder/mock and can be wired to a backend later.

import {
  HandHeart,
  Users,
  Home,
  Bath,
  Sparkles,
  Car,
  BedDouble,
  Compass,
} from "lucide-react";

export const company = {
  name: "MVSD",
  fullName: "Mission \u2022 Value \u2022 Service \u2022 Dedication",
  email: "admin.mvsd@gmail.com",
  website: "mvsd.com.au",
  websiteUrl: "https://mvsd.com.au",
  phone: "0448 426 209",
  phoneRaw: "0448426209",
  acn: "700 665 032",
  address: "Australia Wide",
  tagline: "Compassionate NDIS support that feels like family",
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Our Values", href: "#values" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Enquire", href: "#enquire" },
];

export const services = [
  {
    icon: HandHeart,
    title: "Daily Living Support",
    description:
      "Hands-on assistance with everyday tasks so you can live comfortably and independently in your own home.",
  },
  {
    icon: Users,
    title: "Community Participation",
    description:
      "We help you get out, stay connected and take part in the activities and community you love.",
  },
  {
    icon: Bath,
    title: "Personal Care",
    description:
      "Respectful, dignified help with personal hygiene, dressing, grooming and mobility.",
  },
  {
    icon: Sparkles,
    title: "Household Tasks",
    description:
      "Cleaning, laundry, meal prep and everyday chores handled with care, so home always feels good.",
  },
  {
    icon: Car,
    title: "Transport Assistance",
    description:
      "Safe, friendly transport to appointments, work, social outings and everywhere in between.",
  },
  {
    icon: BedDouble,
    title: "Respite & Short-Term Care",
    description:
      "Quality short-term accommodation and respite that gives everyone a well-deserved break.",
  },
  {
    icon: Compass,
    title: "Support Coordination",
    description:
      "We help you understand your plan and connect the supports that matter most to you.",
  },
];

export const values = [
  {
    letter: "M",
    title: "Mission",
    description:
      "To empower people living with disability to lead meaningful, independent and joyful lives.",
  },
  {
    letter: "V",
    title: "Value",
    description:
      "We treat every participant with genuine respect, dignity and unconditional kindness.",
  },
  {
    letter: "S",
    title: "Service",
    description:
      "Reliable, person-centred support tailored to your goals, your way, every single day.",
  },
  {
    letter: "D",
    title: "Dedication",
    description:
      "A committed team that shows up, listens deeply and truly cares about your wellbeing.",
  },
];

export const aboutPoints = [
  "Person-centred care built around your goals",
  "Caring, experienced and vetted support workers",
  "Flexible support, available Australia wide",
  "Clear communication and no hidden surprises",
];

export const stats = [
  { value: "500+", label: "Lives supported" },
  { value: "24/7", label: "Care availability" },
  { value: "100%", label: "Person-centred" },
  { value: "AU", label: "Wide coverage" },
];

export const testimonials = [
  {
    name: "Sarah M.",
    role: "Participant's mother",
    quote:
      "The MVSD team feels like part of our family. They truly listen and my son has never been happier or more confident.",
    image:
      "https://images.unsplash.com/photo-1765896387377-e293914d1e69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxjYXJlJTIwdGVhbXxlbnwwfHx8fDE3ODY0MTM0NzN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "David T.",
    role: "NDIS Participant",
    quote:
      "My support worker helps me get out into the community and do the things I love. I finally feel independent again.",
    image:
      "https://images.unsplash.com/photo-1658314755707-1fbdf7c40145",
  },
  {
    name: "Emily R.",
    role: "Support Coordinator",
    quote:
      "Reliable, warm and professional. MVSD makes navigating the NDIS so much easier for the families I work with.",
    image:
      "https://images.unsplash.com/photo-1651372381086-9861c9c81db5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxjYXJlJTIwdGVhbXxlbnwwfHx8fDE3ODY0MTM0NzN8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const images = {
  hero: "https://images.unsplash.com/photo-1762955911431-4c44c7c3f408",
  about: "https://images.unsplash.com/photo-1723433892471-62f113c8c9a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxkaXNhYmlsaXR5JTIwc3VwcG9ydHxlbnwwfHx8fDE3ODY0MTM0NzN8MA&ixlib=rb-4.1.0&q=85",
  care: "https://images.unsplash.com/photo-1576560665905-28b4d4ea3380",
  community: "https://images.unsplash.com/photo-1543333995-a78aea2eee50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx3aGVlbGNoYWlyJTIwaG9tZSUyMGNhcmV8ZW58MHx8fHwxNzg2NDEzNDY0fDA&ixlib=rb-4.1.0&q=85",
};
